"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMethod = getMethod;
exports.sanitizeURI = sanitizeURI;
exports.trackClientErrorRetries = trackClientErrorRetries;
exports.maxRetriesExceeded = maxRetriesExceeded;
exports.send = send;
exports.put = exports.post = exports.patch = exports.get = exports.delete = exports.del = exports.RateLimitRecord = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _HTTPVerbs = require("../constants/HTTPVerbs");

var _immutable = _interopRequireWildcard(require("immutable"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _url = require("hub-http/helpers/url");

var _q = _interopRequireDefault(require("q"));

var ALL_NUMS_RE = /\d+/g;
var EMAIL_RE = /\S+@\S+\.\S+/g;
var NOT_FOUND_STATUS_CODE = 404;
var RATE_LIMIT_STATUS_CODE = 429; // these two codes should not get filtered. we have a number of APIs we expect
// to 404 often (e.g. /profile endpoint for deduping new contacts), and we
// can assume that if an API is rate limited then it's not actively causing
// problems and can safely be retried.

var ALWAYS_ALLOW_CODES = [NOT_FOUND_STATUS_CODE, RATE_LIMIT_STATUS_CODE]; // 4 retries === 5 total requests

var MAX_API_RETRIES = 4; // 5 minutes in milliseconds

var RETRY_RATE_LIMIT_TTL = 300000; // rate limit newrelic events to avoid firing too many

var NR_SAMPLE_RATE = 0.35;

var shouldSendToNewRelic = function shouldSendToNewRelic() {
  return Math.random() < NR_SAMPLE_RATE;
};

var RateLimitRecord = (0, _immutable.Record)({
  count: 0,
  lastUpdated: 0
});
exports.RateLimitRecord = RateLimitRecord;

RateLimitRecord.count = function () {
  var oldRecord = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : RateLimitRecord();
  var increment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return oldRecord.merge({
    count: oldRecord.count + increment,
    lastUpdated: Date.now()
  });
};

RateLimitRecord.clear = function (oldRecord) {
  return oldRecord.merge({
    count: 0,
    lastUpdated: Date.now()
  });
};

function getMethod(verb) {
  switch (verb) {
    case _HTTPVerbs.DELETE:
      return _apiClient.default.delete;

    case _HTTPVerbs.GET:
      return _apiClient.default.get;

    case _HTTPVerbs.PATCH:
      return _apiClient.default.patch;

    case _HTTPVerbs.POST:
      return _apiClient.default.post;

    case _HTTPVerbs.PUT:
      return _apiClient.default.put;

    default:
      throw new Error("Unknown http method `" + verb + "`");
  }
}

function getAccept(dataType) {
  switch (dataType) {
    case 'html':
      return 'text/html';

    case 'text':
      return 'text/plain';

    default:
      return undefined;
    // this will make hub-http default to application/json
  }
}

function toJS(data) {
  if (!data || typeof data.toJSON !== 'function') {
    return data;
  }

  return data.toJSON();
}

function sanitizeURI(path) {
  var pathParts = ((0, _url.parseUrl)(path).path || '').split('/');
  var sanitizedParts = pathParts.map(function (part) {
    return decodeURIComponent(part).replace(EMAIL_RE, '*').replace(ALL_NUMS_RE, '*');
  });
  return sanitizedParts.join('/');
}

var clientErrorCounts = (0, _immutable.Map)();

function trackClientErrorRetries(error, uri) {
  var clientErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _immutable.Map)();
  uri = sanitizeURI(uri);

  if (error && error instanceof Error && error.status >= 400 && error.status <= 499 && !ALWAYS_ALLOW_CODES.includes(error.status)) {
    return clientErrors.set(uri, RateLimitRecord.count(clientErrors.get(uri)));
  }

  return clientErrors;
}

function maxRetriesExceeded(uri) {
  var clientErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _immutable.Map)();
  uri = sanitizeURI(uri);
  var recordForURI = clientErrors.get(uri, RateLimitRecord());

  if (Date.now() - recordForURI.lastUpdated > RETRY_RATE_LIMIT_TTL) {
    clientErrors = clientErrors.remove(uri);
    return false;
  }

  return recordForURI.count > MAX_API_RETRIES;
}

function send(config, uri, data) {
  var fromJS = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _immutable.default.fromJS;
  var type = config.type,
      dataType = config.dataType,
      options = (0, _objectWithoutProperties2.default)(config, ["type", "dataType"]);

  if (type === _HTTPVerbs.GET) {
    options.query = toJS(data);
  } else {
    options.data = toJS(data);
  }

  var accept = getAccept(dataType);

  if (accept) {
    options.headers = options.headers || {};
    options.headers.Accept = accept;
  }

  if (maxRetriesExceeded(uri, clientErrorCounts)) {
    // If making changes to RETRY_RATE_LIMIT_TTL, adjust the "5 minutes" text below
    return _q.default.Promise.reject(new Error("ImmutableAPI: max retries exceeded for URI " + sanitizeURI(uri) + " (" + MAX_API_RETRIES + " retries in 5 minutes})"));
  }

  return getMethod(type)(uri, options).then(fromJS).catch(function (error) {
    // handle all TIMEOUT errors and send to newrelic for alerting purposes
    // https://git.hubteam.com/HubSpot/Critsit/issues/807
    if (error && error.errorCode === 'TIMEOUT') {
      var url = error.options && error.options.url || '';

      if (!url) {
        // no URL associated with timeout. just rethrow.
        // shouldn't be possible
        throw error;
      }

      var path = sanitizeURI(url);

      if (window.newrelic && window.newrelic.addPageAction && shouldSendToNewRelic()) {
        window.newrelic.addPageAction('crmApiTimeout', {
          apiPath: path
        });
      }
    }

    clientErrorCounts = trackClientErrorRetries(error, uri, clientErrorCounts);
    throw error;
  });
}

function make(type) {
  return (0, _partial.default)(send, {
    type: type
  });
}

var del = make(_HTTPVerbs.DELETE);
exports.delete = exports.del = del;
var get = make(_HTTPVerbs.GET);
exports.get = get;
var patch = make(_HTTPVerbs.PATCH);
exports.patch = patch;
var post = make(_HTTPVerbs.POST);
exports.post = post;
var put = make(_HTTPVerbs.PUT);
exports.put = put;